import { Stack } from '@fluentui/react';
import { ISemanticStyleHelper } from '../../data-types/styles/ISemanticStyleHelper';

export const stackTokens = { childrenGap: 4 };

export interface ISiteHeaderProps {
    children: React.ReactNode;
    styleHelper?: ISemanticStyleHelper;
    'data-testid'?: string;
    wrap?: boolean;
}

export function SiteHeader(props: ISiteHeaderProps) {
    return (
        <Stack
            styles={props.styleHelper?.siteHeaderStyles.stackStyles}
            tokens={stackTokens}
            verticalAlign="center"
            horizontal
            horizontalAlign="space-between"
            wrap={props.wrap}
            data-testid={props['data-testid']}
        >
            {props.children}
        </Stack>
    );
}
